import {ChangeEvent, useContext, useEffect, useState} from "react";
import {
  CODE, CODE_SUCCESS,
  DEFAULT_PAGE_INDEX, INIT_SEARCH_OBJECT,
  KEY, REGEX,
  SELECTION_MODE,
  WF_TRACKER
} from "../../utils/Constant";
import {handlePagesChange, handleRowsPerPageChange, rowsForPage} from "../../utils/PageUtils";
import {ColumnActionsAssessmentPeriod, ColumnsAssessmentPeriod} from "../columns/AssessmentPeriods";
import WfStatusSummary from "../../workflows/components/WfStatusSummary";
import {deletePhieuNhapKho, searchTechnicalTransferPlans} from "../services/reportAssignment";
import {ConfirmDialog} from "../../component/ConfirmDialog";
import {toast} from "react-toastify";
import {ReportAssignmentContext} from "../ReportAssignment";
import {formatDateDTO, formatDateFromDTOCustom, formatDateToDTOCustom} from "../../utils/FormatUtils";
import {INIT_GENERAL_VALUES, tempImg} from "../constants/reportAssignment";
import {getSummaryStatusWf} from "../../workflows/services/WfWorkflowsService";
import {TableCustom} from "../../component/table/table-custom/TableCustom";
import {TablePagination} from "../../component/table/components/TablePagination";
import InputSearch from "../../component/InputSearch";
import {AppContext} from "../../appContext/AppContext";
import TextField from "../../component/TextField";
import AssignEvaluationDialog from "../dialogs/AssignEvaluationDialog";
import {Button} from "react-bootstrap";
import {getPlans} from "../../build-plan/services/PlanServices";

interface Props {
  className?: any;
}

export const ListDataTable = (props: Props) => {
  const {className} = props;
  const {setIsLoading} = useContext(AppContext);
  const [listData, setListData] = useState<any[]>([]);
  const {setListTableData, setDetailItem, typeForm} = useContext(ReportAssignmentContext);
  const [openDialogConfirmDelete, setOpenDialogConfirmDelete] = useState<boolean>(false);
  const [shouldOpenAssignEvaluationDialog, setShouldOpenAssignEvaluationDialog] = useState<boolean>(false);
  const [itemSelected, setItemSelected] = useState<any>({});
  const [summaryStatus, setSummaryStatus] = useState<any>([]);
  const [searchData, setSearchData] = useState<any>(INIT_SEARCH_OBJECT);
  const [rowsPerPage, setRowsPerPage] = useState<number>(20);
  const [page, setPage] = useState<number>(DEFAULT_PAGE_INDEX);
  const [configTable, setConfigTable] = useState<any>({
    totalPages: 0,
    totalElements: 0,
    numberOfElements: 0,
  });

  const handleChangeSearchData = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchData({
      ...searchData,
      [e.target.name]: e.target.value,
    });
  };

  const handleDelete = async () => {
    try {
      setIsLoading(true);
      const res = await deletePhieuNhapKho(itemSelected.id);
      if (CODE.SUCCESS === res.status) {
        toast.success("Xóa phiếu thành công");
        handleCloseDialog();
      }
    } catch (error: any) {
      const message = error?.message || "Có lỗi xảy ra, vui lòng thử lại";
      toast.error(message)
      setIsLoading(false);
      console.error(error);
    }
  };


  const handleCloseDialog = () => {
    updatePageData();
    setListTableData([]);
    setDetailItem({});
    setOpenDialogConfirmDelete(false);
    setShouldOpenAssignEvaluationDialog(false);
    setItemSelected({
      ...INIT_GENERAL_VALUES,
    });
  };

  const updatePageData = async () => {
    try {
      setIsLoading(true);
      const params = {
        ...searchData,
        startDate: searchData?.startDate ? formatDateDTO(searchData?.startDate) : null,
        endDate: searchData?.endDate ? formatDateDTO(searchData?.endDate) : null,
      };
      const { data } = await getPlans(params);
      if (data?.code === CODE_SUCCESS) {
        const newData = data?.data?.content.map((item: any) => ({
          ...item,
          thumbnail: tempImg,
        }))
        setListData(newData);
        setConfigTable({
          totalPages: data?.data?.totalPages,
          totalElements: data?.data?.totalElements,
          numberOfElements: data?.data?.numberOfElements,
        });
      }
    } catch (error) {
      console.error("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGetSummaryStatus = async () => {
    try {
      setIsLoading(true);
      const resSummary = await getSummaryStatusWf(
        WF_TRACKER.REPORT_ASSIGNMENT,
        {type: null}
      );
      if (CODE.SUCCESS === resSummary.data?.code) {
        setSummaryStatus(resSummary.data.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    updatePageData();
    handleGetSummaryStatus();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPage, page]);


  const handlerSearchKeyWorld = () => {
    setPage(DEFAULT_PAGE_INDEX);
    setRowsPerPage(20);
    updatePageData()
  }

  const handleEdit = (item: any) => {
    setShouldOpenAssignEvaluationDialog(true);
  }

  const columnsActions = ColumnActionsAssessmentPeriod({
    setDetailItem,
    setItemSelected,
    handleEdit,
  });

  return (
    <div className="bg-white h-100">
      <div className="flex-1 flex flex-column">
        <div className="d-flex bg-gray ">
          <div className="spaces width-100 bg-gray radius-2">
            <div className="flex bg-white spaces width-100 ">
              <h4 className="text-title text-pri fw-bold fs-16 spaces mb-0 px-10 min-w-180">
                Danh sách đợt đánh giá
              </h4>
            </div>
            <div className="d-flex  mt-1 flex-column spaces width-100 ">
              <div className="bg-white">
                <div className="d-flex spaces pr-8 mt-6 bg-white justify-content-between align-items-center mb-6">
                  <div className=" bg-white flex align-items-center mr-13 spaces">
                    <Button
                      className="btn-fill ml-10 spaces min-w-90px btn btn-primary"
                      onClick={() => setShouldOpenAssignEvaluationDialog(true)}
                    >
                      <i className="bi bi-plus-lg fs-3"></i>
                      <span>Thêm</span>
                    </Button>
                  </div>
                  <div className="d-flex spaces mx-10 ">
                    <TextField
                      label="Năm"
                      name="year"
                      type="text"
                      value={searchData?.year || ''}
                      className="flex"
                      labelClassName="spaces mt-5 mr-5"
                      onChange={handleChangeSearchData}
                      isInvalid={searchData?.year && !REGEX.YEAR.test(searchData?.year)}
                      errors={"Năm không hợp lệ (1900 - 2100)"}
                    />
                  </div>
                  <div className="d-flex spaces mr-10">
                    <TextField
                      label="Đợt"
                      name="doCreationToDate"
                      type="date"
                      className="flex"
                      value={searchData?.doCreationToDate || ''}
                      labelClassName="spaces mt-5 mr-5"
                      onChange={handleChangeSearchData}
                    />
                  </div>
                  <b className="text-lable-input mb-0 spaces spaces mt-5 mr-5 form-label">Từ khóa</b>
                  <div className="flex-grow-1 ">
                    <InputSearch
                      name="keyword"
                      value={searchData?.keyword || ''}
                      placeholder="Tìm kiếm theo tên kế hoạch"
                      handleChange={handleChangeSearchData}
                      handleSearch={() => handlerSearchKeyWorld()}
                      handleKeyDown={(e: React.KeyboardEvent) => e.key === KEY.ENTER && handlerSearchKeyWorld()}
                      className="spaces h-31 pr-4 radius-3"
                    />
                  </div>
                </div>
                <div className="spaces bg-white mb-0">
                  <TableCustom<any>
                    className={`spaces ${className || "h-bang-ds-phieu"}`}
                    data={listData}
                    columns={ColumnsAssessmentPeriod}
                    columnsActions={columnsActions}
                    verticalScroll={true}
                  />
                  <TablePagination
                    handlePagesChange={handlePagesChange}
                    handleRowsPerPageChange={handleRowsPerPageChange}
                    rowsPerPage={rowsPerPage}
                    rowsForPage={rowsForPage}
                    page={page}
                    setPage={setPage}
                    setRowsPerPage={setRowsPerPage}
                    totalPages={Number(configTable.totalPages)}
                    totalElements={configTable.totalElements}
                    numberOfElements={configTable.numberOfElements}
                    hideTotalElements
                    customComponent={<WfStatusSummary summaryStatus={summaryStatus} col={3}/>}
                    className="border border-0"
                    customComponentClassName="min-w-700px"
                  />
                </div>
              </div>
            </div>
          </div>
          {shouldOpenAssignEvaluationDialog &&
            <AssignEvaluationDialog
              type={typeForm}
              show={shouldOpenAssignEvaluationDialog}
              onHide={handleCloseDialog}
              initialValues={{phanCongDanhGia: {...itemSelected}}}
              setInitialValues={setItemSelected}
            />
          }
          {openDialogConfirmDelete &&
            <ConfirmDialog
              show={openDialogConfirmDelete}
              onCloseClick={handleCloseDialog}
              onYesClick={handleDelete}
              title="Xóa phiếu"
              message={`Bạn chắc chắn muốn xóa phiếu: ${itemSelected.code} ?`}
              yes="Xóa"
              close="Hủy"
            />
          }
        </div>
      </div>
    </div>
  )
}

export default ListDataTable;
